module.exports = __webpack_public_path__ + "img/zwischenzeiten7.0ef8730d.jpg";